import React, { useState } from "react";
import EditProfile from "./EditProfile";
import Preferences from "./Preferences";
import Billing from "./Billing";


const Profile = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = ["Edit Profile","Billing","Preferences",]

  const renderActiveTab = () => {
    switch (activeTab) {
      case 0:
        return <EditProfile />;
      case 1:
        return  <Billing />;
      case 2:
        return <Preferences />;
     
      default:
        return <EditProfile />;
    }
  };



const TabMenu = ({ tabs, activeTab, onTabClick }) => {
  return (
    <div className="flex border-b mb-4">
      {tabs.map((tab, index) => (
        <button
          key={index}
          onClick={() => onTabClick(index)}
          className={`px-4 py-2 font-medium text-sm ${
            activeTab === index ? "border-b-2 border-indigo-500 text-indigo-500" : "text-gray-500"
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};




  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <TabMenu tabs={tabs} activeTab={activeTab} onTabClick={setActiveTab} />
      <div className="mt-6">{renderActiveTab()}</div>
    </div>
  );
};

export default Profile;
